import { IProxy } from "@interfaces/admin/proxy";
import style from "./OperatorSelectCell.module.scss";
import cn from "classnames";
import { useUpdateProxyDataMutation } from "@RTKQuery/admin/proxy/proxy";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { useEffect } from "react";
import { removeRowError } from "@global-state/pages/admin/myProxies/slice";
import { EOperator } from "@interfaces/operator.enum";
import { ArrowSvg, KyivstarSvg, LifecellSvg, VodafoneSvg } from "../../svg";
import { Chip, Select } from "@ui";
import { IoClose } from "react-icons/io5";

const listOperators = [
    {
        label: EOperator.Kyivstar,
        value: EOperator.Kyivstar
    },
    {
        label: EOperator.Vodafone,
        value: EOperator.Vodafone
    },
    {
        label: EOperator.lifecell,
        value: EOperator.lifecell
    }
]

export function OperatorSelectCell({
    data,
    setShowChildren,
    showChildren,
    isParent = true
}: {
    data: {
        id: IProxy["id"],
        operator: IProxy["operator"],
        children?: IProxy["children"],
        parent_id: IProxy["parent_id"]
    },
    setShowChildren: React.Dispatch<React.SetStateAction<boolean>>,
    showChildren: boolean,
    isParent?: boolean
}) {
    const [updateProxyData, { isSuccess, reset }] = useUpdateProxyDataMutation();

    const { activePaginationLimit, activePaginationPage, activeSearchIdParameter, activeSearchPhoneParameter, activeOperator, activeSelling } = useAppSelector(state => state.myProxiesAdminPage);

    const rowsIsError = useAppSelector(state => state.myProxiesAdminPage.rowsIsError)?.[data.id] || [];

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (isSuccess) {
            dispatch(removeRowError({
                proxyId: data.id,
                colName: "operator"
            }))
        }
    }, [isSuccess])

    return (
        <div className={style.cell}>
            <div className={cn(
                "flex items-center select-none gap-[7px]",
                (data.children && (data.children.length > 0)) && "cursor-pointer",
                !isParent && "pl-[20px]")}
            >

                {
                    {
                        [EOperator.Kyivstar.toLocaleLowerCase()]: <KyivstarSvg />,
                        [EOperator.Vodafone.toLocaleLowerCase()]: <VodafoneSvg />,
                        [EOperator.lifecell.toLocaleLowerCase()]: <LifecellSvg />,
                    }[data.operator.toLocaleLowerCase()]
                }

                <Select
                    currentValue={listOperators.find(item => item.value.toLocaleLowerCase() === data.operator.toLocaleLowerCase()) || {
                        label: "Unknown",
                        value: "Unknown"
                    }}
                    listValues={listOperators}
                    onChange={(value) => {
                        updateProxyData({
                            proxy_id: data.id,
                            parent_id: data.parent_id || undefined,
                            params: {
                                page: activePaginationPage,
                                limit: activePaginationLimit,
                                router_id: activeSearchIdParameter,
                                operator: activeOperator,
                                phone_number: activeSearchPhoneParameter,
                                selling: activeSelling
                            },
                            body: {
                                operator: value.value as EOperator
                            }
                        })
                    }}
                />
                {
                    isParent && data.children && data.children.length > 0
                        ? <ArrowSvg
                            className={showChildren ? "rotate-[180deg]" : "rotate-[0]"}
                            onClick={() => {
                                if (data.children && (data.children.length > 0)) {
                                    setShowChildren((state) => !state)
                                }
                            }}
                        />
                        : null
                }
            </div>

            <div className={cn("absolute left-full top-1/2 z-10 pl-[5px] -translate-y-1/2", rowsIsError.includes("operator") ? "block" : "hidden")}>
                <Chip
                    text="Помилка"
                    color="red"
                    icon={<IoClose
                        className="w-[15px] text-[#F81F1F] h-[15px] cursor-pointer"
                        onClick={() => {
                            reset();
                            dispatch(removeRowError({
                                proxyId: data.id,
                                colName: "operator"
                            }))
                        }}
                    />}
                    aligtIcon="right"
                />
            </div>
        </div>
    )
}